export class DateValidator {
  static dateValidator(date: any) {

    const mes = +date?.value?.slice(0, 2);
    const ano = +date?.value?.slice(2, 4);
    const mesAtual = new Date()?.getMonth() + 1;
    const anoAtual = new Date()?.getFullYear() % 100;

    if ((date?.value?.length === 4) && (mes === 0 || (ano < anoAtual) || (ano == anoAtual && mes < mesAtual))) return { 'dateValidator': true };

    return null;
  }
}
